import useCompanyContext from 'common/hooks/useCompanyContext';
import useErrorHandledMutation from 'common/hooks/useErrorHandledMutation';

import { PaymentCardsListDocument } from '../../../../../../hooks/usePaymentCardsList/paymentCardsList.gql';
import {
  ActivatePhysicalPaymentCardDocument,
  ActivatePhysicalPaymentCardMutation,
  ActivatePhysicalPaymentCardMutationVariables,
} from './activatePhysicalPaymentCard.gql';

export const useActivatePhysicalPaymentCard = () => {
  const { companyProfileId, companyUserId } = useCompanyContext();

  if (!companyProfileId) {
    throw new Error(
      'companyProfileId is undefined in "useActivatePhysicalPaymentCard"',
    );
  }

  if (!companyUserId) {
    throw new Error(
      'companyUserId is undefined in "useActivatePhysicalPaymentCard"',
    );
  }

  return useErrorHandledMutation<
    ActivatePhysicalPaymentCardMutation,
    ActivatePhysicalPaymentCardMutationVariables
  >(ActivatePhysicalPaymentCardDocument, {
    refetchQueries: [
      {
        query: PaymentCardsListDocument,
        variables: { companyProfileId, companyUserId },
      },
    ],
  });
};
